// vendor
import { defineComponent, computed, ref, watch } from "@vue/composition-api";
// project
import { TitleHeader } from "@/components.nav/title-header";
import { useTranslate } from "@lang";
// local
import { default as ItemFoldout } from "./item-foldout.vue";
import { default as ListFavourites } from "./list-favourites.vue";
import { default as ListAssets } from "./list-assets.vue";
import { default as ListCategories } from "./list-categories.vue";


type Dictionary<T> = { [k:string]:T };

const getSavedFoldout = (name:string, defValue:boolean):boolean => {
	const v = localStorage.getItem(`nav.foldout.${name}`);
	return v ? JSON.parse(v) : defValue;
};

const saveFoldout = (name:string, v:boolean):void => {
	localStorage.setItem(`nav.foldout.${name}`, v.toString());
};

const options = [
	{
		title: "Home",
		route:"home",
		icon:"mdi.home",
	},
	{
		title: "Assets",
		route:"assets",
		icon:"mdi.layers",
	},
	{
		title: "Studies",
		route:"studies",
		icon:"mdi.rocket",
	}
];

export const NavLeft = defineComponent({
	emits:[
		"close-menu"
	],
	components:{
		TitleHeader,
		ItemFoldout,
		ListFavourites,
		ListAssets,
		ListCategories,
	},
	setup(props, context){

		const {
			translate
		} = useTranslate();


		const foldouts = ref<Dictionary<boolean>>({
			"favourites":getSavedFoldout("favourites", false),
			"assets":getSavedFoldout("assets", false),
		});

		const navOptions = computed(() => {
			return options;
		});

		const getRoute = (index:number) => {
			const option = navOptions.value[index];
			const q:any = {};
			[ "t" ].forEach(qk => {
				if(context.root.$route.query[qk]){
					q[qk] = context.root.$route.query[qk];
				}
			});
			return {
				name:option.route,
				query:q
			};
		};

		const getNavClass = (option:any) => {
			var isActive = isRoute(option);
			var ic = option.class ? option.class : '';
			var c = (isActive ? 'text-white' : 'text-muted pointer') + ' ' + ic;
			return c;
		};
	
		const isRoute = (option:any) => {
			if(!context.root.$route.name){ return false; }
			let res = context.root.$route.name.match(`${option.route}*`);
			return Boolean(res);
		};
	
		const isExactRoute = (option:any) => {
			return option.route === context.root.$route.name;
		};

		const hideMenu = () => {
			context.emit("close-menu");
		};
		
		Object.keys(foldouts.value)
		.forEach(k => watch(() => foldouts.value[k], (v) => saveFoldout(k, v)));

		return {
			navOptions,
			foldouts,
			translate,
			getNavClass,
			isRoute,
			isExactRoute,
			hideMenu,
			getRoute,
		};

	}
});